<template>
	<div id="cale">
		<!-- BEGIN calendar -->
		<FullCalendar ref="calendar" :options="calendarOptions"></FullCalendar>
		<!-- END calendar -->
	</div>
</template>


<style scoped lang="less">
	/deep/ .acitavedate {
		background: #e3bebe !important;
	}
</style>

<script>
	import '@fullcalendar/core/vdom' // solves problem with Vite
	import FullCalendar from '@fullcalendar/vue'
	import dayGridPlugin from '@fullcalendar/daygrid'
	import timeGridPlugin from '@fullcalendar/timegrid'
	import interactionPlugin from '@fullcalendar/interaction'
	import listPlugin from '@fullcalendar/list'
	import bootstrapPlugin from '@fullcalendar/bootstrap'
	import $ from "jquery"

	export default {
		components: {
			FullCalendar // make the <FullCalendar> tag available
		},
		props: {
			oknumlist: Array,
			powerlist: Array,
			name: String
		},

		data() {
			return {
				calendarOptions: {
					allDayText: "全天",
					locale: "zh-cn", // 中文

					plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin, bootstrapPlugin],
					headerToolbar: {
						left: 'dayGridMonth,timeGridWeek,timeGridDay',
						center: 'title',
						right: 'prevMonthCustom,nextMonthCustom todayCustom'
					},
					buttonText: {
						today: '本月',
						month: '月视图',
						week: '周视图',
						day: '日期视图',
						next: '下一月',
						prev: "上一月"
					},
					initialView: 'dayGridMonth',
					height: "auto",
					editable: false,
					droppable: true,
					themeSystem: 'bootstrap',
					views: {
						timeGrid: {
							eventLimit: 6 // adjust to 6 only for timeGridWeek/timeGridDay
						}
					},
					events: [],
					//这个事件是  点击插件里面的单条数据时触发
					eventClick: this.handleEventClick,
					//这个事件是 当你点击日期单元格时触发
					dateClick: this.handleDateClick,
					// 自定义按钮
					customButtons: {
						prevMonthCustom: {
							text: '上月',
							click: this.prevMonthCustomClick

						},
						nextMonthCustom: {
							text: '下月',
							click: this.nextMonthCustomClick

						},
						todayCustom: {
							text: '今天',
							click: this.todayCustomClick
						}
					},
				},
				oknumlists: [],
				powerlists: [],
				calendarApi: {},
				// 日期选中
				currentYear: new Date().getFullYear(),
				currentMonth: new Date().getMonth() + 1 <10?"0"+(new Date().getMonth() + 1): new Date().getMonth() + 1,
				datelist: this.getMonthDate()

			}
		},
		watch: {
			oknumlist(val) {
				this.oknumlists = val
				// console.log(val,"获取")
				this.setcalendarOptions()

			},
			powerlist(val) {
				this.powerlists = val
				// console.log(val, "获取list")
				this.setcalendarOptions()
			}

		},
		beforeMount() {},
		mounted() {
			this.setcalendarOptions()
			this.calendarApi = this.$refs.calendar.getApi() //一旦你有ref，你可以通过getApi方法得到底层的日历对象: 
		},
		methods: {
			// 上月点击
			prevMonthCustomClick() {
				this.calendarApi.prev(); // 调用next方法
				let test = this.calendarApi.getCurrentData().currentDate;
				// console.log(new Date(test).getMonth() + 1, "上月点击")
				this.currentYear = new Date(test).getFullYear()
				this.currentMonth = new Date(test).getMonth() + 1
				this.datelist = this.getMonthDate(new Date(test))
				this.setcalendarOptions()
			},
			// 下月点击
			nextMonthCustomClick() {
				this.calendarApi.next(); // 调用next方法
				let test = this.calendarApi.getCurrentData().currentDate;
				// console.log(new Date(test).getMonth() + 1, "下月点击")
				this.currentYear = new Date(test).getFullYear()
				this.currentMonth = new Date(test).getMonth() + 1
				this.datelist = this.getMonthDate(new Date(test))
				this.setcalendarOptions()
			},
			// 今日点击
			todayCustomClick() {
				// FullCalendar.today();
				this.calendarApi.today();
				let test = this.calendarApi.getCurrentData().currentDate;
				this.currentYear = new Date().getFullYear()
				this.currentMonth = new Date().getMonth() + 1
				this.datelist = this.getMonthDate(new Date(test))
				this.setcalendarOptions()
			},

			// 点击日程触发
			handleEventClick(data) {
				// console.log(data.event)
			},

			// 点击日期触发事件
			handleDateClick(data1) {
				// console.log(data1, "1111")
				$(data1.dayEl).parents("table").contents().eq(1).find("td").removeClass("acitavedate")
				$(data1.dayEl).addClass("acitavedate")
				var testArr1 = this.oknumlist.map(Number)
				// console.log(testArr1)
				// console.log(this.getWeek(data1.dateStr))
				if (testArr1.indexOf(this.getWeek(data1.dateStr)) >= 0) {
					// console.log("可以预约")
					let timerobj = {
						dates: data1.dateStr,
						names: 1
					}
					if (this.name != "实训设备") {
						this.$parent.changetimer(timerobj)
					}

				} else {
					// console.log("不可预约")
					let timerobjerr = {
						dates: data1.dateStr,
						names: 0
					}
					this.$parent.changetimer(timerobjerr)
				}



			},


			setcalendarOptions() {
				let eventslist = []
				// console.log(this.powerlists, "获取预约记录")
				let newArr = this.oknumlist.map(Number)
				var testArr = newArr;



				// this.currentMonth = (this.currentMonth < 10) ?"0" + this.currentMonth : this.currentMonth;

				this.powerlists.forEach(item => {
					// console.log(item.ap_appDate.slice(0, 8), "字符串截取")
					let endnums = Number(item.ap_appDate.slice(-2)) + 1
					// console.log(item.ap_appDate.slice(0, 8) + endnums, "字符串截取")
					let poweryobj = {
						title: item.ap_auditState + "  人数已预约" + "      " + item.ap_reservedNum,
						start: item.ap_appDate,
						end: item.ap_appDate.slice(0, 8) + endnums,
						color: item.ap_auditState == "待审核" ? '#F89C2C' : item.ap_auditState == "已完成" ?
							"#48d800" : item.ap_auditState == "审核通过" ? "#48d800" : "#FB5597"
					}
					let prowertimerobj = {
						title: item.ap_startTime + "~" + item.ap_endTime,
						start: item.ap_appDate + 'T' + item.ap_startTime,
						end: item.ap_appDate + 'T' + item.ap_endTime,
						color: '#367ff5'
					}
					eventslist.unshift(poweryobj)
					eventslist.push(prowertimerobj)
				})

				// console.log(this.currentMonth)
				// 根据oknumlist判断预约周
				this.datelist.forEach((item, index) => {
					let strattime = this.currentYear + '-' + this.currentMonth + '-' + item.slice(-2)
					let entime = this.currentYear + '-' + this.currentMonth + '-' + (parseInt(item.slice(-2)) + 1)
					// console.log(testArr.indexOf(this.getWeek(item)),)

					if (testArr.indexOf(this.getWeek(item)) >= 0 && Date.parse(strattime) >= Date.parse(new Date()
							.toLocaleDateString())) {
						let eventobj = {
							title: '可预约',
							start: strattime,
							end: entime,
							color: '#24ac1a'
						}
						eventslist.push(eventobj)
						// console.log("可约")
					} else {
						let eventobj1 = {
							title: '不可预约',
							start: strattime,
							end: entime,
							color: '#9f9f9f'
						}
						eventslist.push(eventobj1)
					}
				})

				// console.log(eventslist, "总预约数据")
				this.calendarOptions.events = eventslist

			},

			getWeek(day) {
				// console.log(day)
				var daymouth = [7, 1, 2, 3, 4, 5, 6]
				var weeknum = new Date(day).getDay()
				var weekmouth = daymouth[weeknum]
				// console.log(weekmouth)
				return weekmouth

			},
			// 获取月份所有的天数组成数组
			getMonthDate(date) {
				let nowdays = date ? new Date(date) : new Date();

				let year = nowdays.getFullYear();
				let month = nowdays.getMonth() + 1;
				if (month < 10) {
					month = "0" + month;
				}
				let myDate = new Date(year, month, 0);
				// console.log(myDate.getDate());
				let tempList = [];
				for (let i = 1; i <= myDate.getDate(); i++) {
					if (i < 10) {
						tempList.push(year + "-" + month + "-" + "0" + i);
					} else {
						tempList.push(year + "-" + month + "-" + i);
					}
				}
				return tempList;
			}


		}


	}
</script>
